import { CommonResponse } from 'models/common';
import axiosClient from 'utils/axiosClient';
import { SelectMenu } from './models';

export interface MenuServiceGetAllFilterPayload {
  selectedIds: number[];
  foodSystemMenuName: string;
  foodSystemMenuCd: string;
}

const menuService = {
  getAll({
    selectedIds = [],
    foodSystemMenuName = '',
    foodSystemMenuCd = '',
  }: MenuServiceGetAllFilterPayload): Promise<CommonResponse<SelectMenu[]>> {
    const strSelectedIds = selectedIds.length > 0 ? selectedIds.join(',') : '';
    const url = `/menus?selected_ids=${strSelectedIds}&food_system_menu_name=${foodSystemMenuName}&food_system_menu_cd=${foodSystemMenuCd}&display_type=1`;
    return axiosClient.get(url);
  },
};

export default menuService;
